import { render, staticRenderFns } from "./IconKebab.vue?vue&type=template&id=2abeb202&scoped=true&functional=true&"
import script from "./IconKebab.vue?vue&type=script&lang=ts&"
export * from "./IconKebab.vue?vue&type=script&lang=ts&"
import style0 from "./IconKebab.vue?vue&type=style&index=0&id=2abeb202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2abeb202",
  null
  
)

export default component.exports